<div class="auth-pages-container">
  <router-outlet/>
</div>
